module.exports = __webpack_public_path__ + "static/media/main21.91266116.png";